// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"Tabs_tabHeader__Ybx2C","active":"Tabs_active__mZ2aO","inactive":"Tabs_inactive__uLsJe","activeGrey":"Tabs_activeGrey__1pbgw","inactiveGrey":"Tabs_inactiveGrey__SVT3z"};